import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useStore } from "../store";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faUpload,
  faChevronDown,
  faChevronUp,
  faPaste,
} from "@fortawesome/free-solid-svg-icons";
import CardComponentDataSummary from "../components/CardComponentDataSummaryLida";
import { Colors } from "../utils/style";
import ExplorationContainer from "../components/ExplorationContainer";
import PredictiveContainer from "../components/PredictiveContainer";
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";

import { axiosInstance, getUserFilesNames } from "../App";
import CreditModal from "../components/CreditModal";

type propTypes = { title?: string };

type Summary = {
  fields: {
    column: string;
    properties: {
      dtype: string;
      semantic_type: string;
      description: string;
      samples: string[];
    };
  }[];
  field_names: string[];
  categorical_fields: string[];
  boolean_fields: string[];
  numerical_fields: string[]
};

type Goal = {
  question: string;
  visualization: string;
  rationale: string;
};

function CreditRisk(props: propTypes) {
  const { visualisation, setVisualisation } = useStore();
  const { summary, setSummary } = useStore();
  const { analyse, setAnalyse } = useStore();
  const { prediction, setPrediction } = useStore();


  const [showVisualization, setShowVisualization] = useState(true);
  const [showDataSummary, setShowDataSummary] = useState(true);

  const { selectedFileName, setSelectedFileName } = useStore();
  const [urlFileName, setUrlFileName] = useState<string>("");
  const { explanations, setExplanations } = useStore();
  const { interpretations, setIinterpretations } = useStore();
  const { userFilesNames, setUserFilesNames } = useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [gaolsLoading, setGaolsLoading] = useState(false);
  const [visualisationLoading, setVisualisationLoading] = useState(false);
  const [uploadError, setUploadError] = useState(false);

  const [visualisationError, setVisualisationError] = useState(false);
  const {t} = useTranslation('creditRisk');

  function getSummary(selectedFile: string) {
    const formData = new FormData();
    setLoading(true);

    const body = {
      //filename: selectedFileName,
    };

    axiosInstance
      .get(
        process.env.REACT_APP_API_HOST + "summarize_user_file/" + selectedFile,

        {
          headers: {
            "Content-Type": "application/json",
            "Referrer-Policy": "no-referrer",
            Authorization: "Bearer " + localStorage.getItem("tokenLida"),
            "Accept-Language": i18n.language, // Add current language
          },
        }
      )
      .then((response) => {
        setSummary(response.data.summary);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }
  function sendPATHToGenerateSummary(path: string, fileName: string) {
    const body = {
      path: path,
      n: 5,
      textgen_config: {
        temperature: 0,
        n: 1,
        model: "gpt-3.5-turbo-0301",
        max_tokens: null,
        provider: "openai",
      },
    };
    setUrlFileName(fileName);
    setUploadError(false);
    setLoading(true);
    setSummary(null);
    axiosInstance
      .post(process.env.REACT_APP_API_HOST + "summarize/path", body, {
        headers: {
            "Content-Type": "application/json",
            "Referrer-Policy": "no-referrer",
            Authorization: "Bearer " + localStorage.getItem("tokenLida"),
            "Accept-Language": i18n.language, // Add current language
        },
      })
      .then((response) => {
        setSummary(response.data.summary);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }
  function sendFile(selectedFile: File | null) {
    setSelectedFileName(selectedFile ? selectedFile.name : null);

    if (!selectedFile) {
      return;
    }
    setLoading(true);

    const formData = new FormData();
    formData.append("file", selectedFile);
    initialiseAll();

    axiosInstance
      .post(
        process.env.REACT_APP_API_HOST + "upload_save_file" + "?overwrite=true",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Referrer-Policy": "no-referrer",
            Authorization: "Bearer " + localStorage.getItem("tokenLida"),
            "Accept-Language": i18n.language, // Add current language
          },
        }
      )
      .then((response) => {
        setLoading(false);
        getSummary(selectedFile.name);
        getUserFilesNames(setUserFilesNames);
      })
      .catch((error) => {
        setLoading(false);
        setUploadError(true);
        console.error("Error uploading file:", error);

        if (error.response && error.response.status === 402) {
          // Show payment modal
          setIsModalOpen(true);
        }
      });
  }

  function onUserFilesNamesClick(fileName: string) {
    setSelectedFileName(fileName);
    initialiseAll();
    getSummary(fileName);
  }
  function initialiseAll() {
    setLoading(true);
    setSummary(null);
    setExplanations(null);
    setIinterpretations(null);
    setAnalyse(null);
    setSelectedFileName(null);
    setPrediction(null);
  }

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
      setUploadError(false);
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files ? event.target.files[0] : null;
    sendFile(selectedFile);
  };
    const uploadOptionsForDemo = [
    {
      name: "loan_data.csv",
      path: "loan_data.csv",
    }]

  return (
    <div>
      <Container className="mt-4 mb-4">
        <div className="mb-5 mt-5">
          <h2 style={{ color: Colors.DARK_BLUE }}>
            {t("CreditRiskAssessment")}
          </h2>
        </div>

        <div
        style={{
          textAlign: "left",
          fontSize: "18px",
          color: Colors.DARK_BLUE,
        }}
      >
        {
          t("CreditRiskAssessmentDescription")
        }
        {" "}
        </div>
        <div
          className="p-3 text-center "
          onClick={handleDivClick}
          style={{
            cursor: "pointer",
            backgroundColor: "#e5e4e2",
            borderStyle: "dashed",
            borderColor: Colors.DARK_BLUE,
          }}
        >
          {/* Icon */}
          <FontAwesomeIcon
            icon={faUpload}
            size="3x"
            color={Colors.DARK_BLUE}
            className="mb-3"
          />

          {/* Your content goes here */}
          <h2 style={{ color: Colors.DARK_BLUE }}>
            {t("ClickToUpload")}
          </h2>
          <p style={{ color: Colors.DARK_BLUE }}>
            {t("UploadInstruction")}
          </p>
          {/* Hidden file input */}
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>
        {selectedFileName && (
          <div className="mt-3">
            <FontAwesomeIcon icon={faPaperclip} />
            <strong>{t("SelectedFile")}:</strong> {selectedFileName}
          </div>
        )}
        <div className="mt-3">
          {" "}
          <p>{t("ExistingData")} </p>
        </div>
        <div className="mt-3">
          {userFilesNames?.map((fileName, index) => (
            <React.Fragment key={index}>
              <Button
                variant="light"
                className="border border-success  p-2"
                style={{ margin: "0.5rem" }}
                onClick={() => onUserFilesNamesClick(fileName)}
              >
                {fileName}
              </Button>
            </React.Fragment>
          ))}
        </div>
        <div className="mt-3">
          {" "}
          <p>{t("UseExample")} </p>
        </div>
        <div className="mt-3">
          {uploadOptionsForDemo.map((p) => (
            <Button
              variant="light"
              className="border border-success  p-2"
              style={{ margin: "0.5rem" }}
              onClick={() => sendPATHToGenerateSummary(p.path, p.name)}
            >
              {p.name}
            </Button>
          ))}
        </div>


        {loading && (
          <div
            className="mt-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Spinner
              animation="grow"
              variant="success"
              style={{ marginRight: "0.2rem" }}
            />

            <div>
              {t("UploadingData")}
            </div>
          </div>
        )}
        {uploadError && (
                    <></>

        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "1rem",
          }}
          className="mt-3"
        >
          <FontAwesomeIcon icon={faPaste} size="2x" color={Colors.DARK_BLUE} />
          <div
            style={{
              textAlign: "left",
              fontSize: "25px",
              fontWeight: "bold",
              color: Colors.DARK_BLUE,
            }}
          >
            {t("DataSummary")}
          </div>
        </div>
        <div
          style={{
            textAlign: "left",
            fontSize: "18px",
            color: Colors.DARK_BLUE,
          }}
        >
          {
            t("DataSummaryDescription")
          }
        </div>
        {/* separator */}
        <Card
          style={{
            backgroundColor: "#e5e4e2",
          }}
          onClick={() => {
            setShowDataSummary(!showDataSummary);
          }}
          className="mt-3"
        >
          <Card.Body
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <FontAwesomeIcon
              icon={!showDataSummary ? faChevronDown : faChevronUp}
              size="1x"
            />
            <div>{summary?.dataset_description || "Data Summary"} </div>
          </Card.Body>
        </Card>
        {showDataSummary && (
          <>
            <Container className="mt-3">
              <Row md={2} xs={1} lg={3} sm={2}>
                {summary?.fields.map((d) => (
                  <Col style={{ padding: "0.5rem" }}>
                    <CardComponentDataSummary
                      title={d.column}
                      icone={undefined}
                      typeX={d.properties?.dtype || ""}
                      typeY={d.properties?.semantic_type || ""}
                      description={d.properties?.description || ""}
                      samples={d.properties?.samples || ""}
                    ></CardComponentDataSummary>
                  </Col>
                ))}
              </Row>
            </Container>
          </>
        )}
        {summary && (
          <>
            <div>
              <ExplorationContainer
                fileName={(selectedFileName && selectedFileName) || urlFileName}
              ></ExplorationContainer>
            </div>
            {analyse && (
              <div>
                <PredictiveContainer
                  fileName={
                    (selectedFileName && selectedFileName) || urlFileName
                  }
                ></PredictiveContainer>
              </div>
            )}
          </>
        )}
      </Container>
    
    
    </div>
  );
}

export default CreditRisk;
